import { Component, OnInit, Input } from '@angular/core';
import { SetService } from 'ngx-block-core';
import { HttpService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { FormControlService } from "ngx-block-core";
import { selectSize } from "../../../data/data";

@Component({
  selector: 'app-sucu04-weiget0020002',
  templateUrl: './sucu04-weiget0020002.component.html',
  styles: [
  ]
})
export class Sucu04Weiget0020002Component implements OnInit {
  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'

  @Input() sets = {
    blockCode: "sucublock44",
    blockId: "",
    blockName: "联级下拉",
    layoutId: "",
    blockType: "formBlock",
    blockChildType: '',
    versionCode: 4,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    styles: {
      nzText: "编号: ",
      nzSize: "default",
      nzPlaceHolder: "请输入内容",
      nzMinWidth: 100,
      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12
      },
      nzAllowClear: true,
      nzShowSearch: true,
      nzMode: 'default',
      nzMaxMultipleCount: 100,
      nzRequired: false,
      nzHasFeedback: false,
      nzChangeOnSelect: false,
      nzNoSee: false
    },
    datas: {
      nzDynamicData: false,
      nzDynamicSearch: {
        nzDynamicSets: [
          {
            tableName: "",
            value: "",
            label: "",
            columnName: [],
            dynamicCondition: "",
            next: {
              mode: "",//crosstable,sametable
              parentId: [
                {
                  name1: "",
                  name2: "",
                  operation: "",
                  parentType: ""
                }
              ],
              childField: [
                {
                  name1: "",
                  name2: "",
                  operation: "=",
                  parentType: "and"
                }
              ]
            }
          }
        ]
      },
      nzData: [],
    }
  };

  setData = []
  nzData = [];

  constructor(
    public setService: SetService,
    private http: HttpService,
    private formControlService: FormControlService,

  ) { }
  ngOnInit() {
    this.baseInit();
    this.nzData = [...this.sets.datas.nzData];
    if (this.sets.datas.nzDynamicData) {
      this.initSelected();
    }

  }

  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 3) {

      this.sets.blockCode = "sucublock44";

      this.sets.versionCode = 3;
    }
    //v3,升级自定义表单参数
    if (this.sets.versionCode < 4) {
      if (typeof this.sets.styles.nzNoSee == "undefined")
        this.sets.styles.nzNoSee = false;
      this.sets.versionCode = 4;
    }

  }


  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' },
              { name: 'nzDynamicSearch', inputs: { nzMode: 'tree' } },
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "可搜索 : ", nzKeys: ['styles', 'nzShowSearch'], }
              },
              {
                name: 'switch',
                inputs: { nzText: "可清除 : ", nzKeys: ['styles', 'nzAllowClear'], }
              },
              {
                name: 'switch',
                inputs: { nzText: "可选父级 : ", nzKeys: ['styles', 'nzChangeOnSelect'], }
              },
              {
                name: 'input',
                inputs: { nzText: "提示文字 : ", nzKeys: ['styles', 'nzPlaceHolder'] }
              },
              { name: 'nzLayout', inputs: { nzType: '选择框' } },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
              },
              {
                name: 'switch',
                inputs: { nzText: "显示必选* : ", nzKeys: ['styles', 'nzRequired'], nzPopContent: ['仅影响样式'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "校验图标 : ", nzKeys: ['styles', 'nzHasFeedback'], nzPopContent: ['校验状态的图标'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "wholearray";
                  }
                }
              },
            ]
          },
        ]
      },
      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      }
    ]
  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.autoUpdate();
        this.nzFormGroupData['nzSearchDataType'] = "wholearray";
        if (this.sets.styles.nzNoSee == true)
          this.nzFormGroupData['nzSearchDataType'] = "noSee";
        if (this.nzFormGroupData['nzSearchType'] == 'null')
          this.nzFormGroupData['nzSearchType'] = "=";
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }
       
        this.pzListening()
      }
      else {//静态
        if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
        this.autoUpdate();
      }
    }
  }
  ngOnDestroy() {
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz');
    if (this.nzTimer) {
      clearInterval(this.nzTimer);
    }
  }
  onChanges(event) {

  }
  //定时器
  private nzTimer;
  initSelected() {

    this.nzData = [{
      value: 'loading',
      label: '加载中...',
      isLeaf: true,
      disabled: true
    }];
    // 组装body
    let finalData = this.sets.datas.nzDynamicSearch.nzDynamicSets[this.sets.datas.nzDynamicSearch.nzDynamicSets.length - 1];
    if (finalData.next.mode == "sametable") {
      if (finalData.next.parentId[0].name1 != 'value' && finalData.next.parentId[0].name1 != 'label')
        finalData.columnName.push(finalData.next.parentId[0].name1);
      if (finalData.next.parentId[0].name1 != finalData.next.parentId[0].name2 && finalData.next.parentId[0].name2 != 'value' && finalData.next.parentId[0].name2 != 'label')
        finalData.columnName.push(finalData.next.parentId[0].name2);
    } else if (finalData.next.mode == "crosstable") {
      finalData.next.childField.forEach(element => {
        if (finalData.columnName.indexOf(element.name1) == -1 && element.name1 != 'value' && element.name1 != 'label')
          finalData.columnName.push(element.name1);
      });
    }
    finalData.next.childField[0].parentType = "";
    for (let index = this.sets.datas.nzDynamicSearch.nzDynamicSets.length - 2; index >= 0; index--) {
      const data = this.sets.datas.nzDynamicSearch.nzDynamicSets[index];
      const linshidata = finalData;
      finalData = data;

      if (finalData.next.mode == "sametable") {
        if (finalData.next.parentId[0].name1 != 'value' && finalData.next.parentId[0].name1 != 'label')
          finalData.columnName.push(finalData.next.parentId[0].name1);
        if (finalData.next.parentId[0].name1 != finalData.next.parentId[0].name2 && finalData.next.parentId[0].name2 != 'value' && finalData.next.parentId[0].name2 != 'label')
          finalData.columnName.push(finalData.next.parentId[0].name2);
      } else if (finalData.next.mode == "crosstable") {
        finalData.next.childField.forEach(element => {
          //父级设置
          if (finalData.columnName.indexOf(element.name1) == -1 && element.name1 != 'value' && element.name1 != 'label')
            finalData.columnName.push(element.name1);
          //子级设置
          if (linshidata.columnName.indexOf(element.name2) == -1 && element.name2 != 'value' && element.name2 != 'label')
            linshidata.columnName.push(element.name2);
        });
      }
      finalData.next.childField[0].parentType = "";

      finalData['child'] = linshidata;
    }
    if (!this.nzTimer) {
      const load = [
        '·', '··', '···', '····', '·····', '······'
      ]
      let index = 0;
      this.nzTimer = setInterval(() => {
        this.nzData[0].label = "加载中" + load[(index++) % 6]
      }, 300)
    }

    this.http.postHttp("/system/cascaderData", finalData).subscribe(
      (data: any) => {
        if (this.nzTimer) {
          clearInterval(this.nzTimer);
          this.nzTimer = null
        }
        this.nzData = [...data.data];
      });
  }
  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        console.log("type", data['type']);

        switch (data['type']) {
          case 'changeFormValid':
            this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
            break;
          case 'refresh':
            this.initSelected();
            break;
          case 'refreshstatic':
            this.nzData = [...this.sets.datas.nzData];
            break;
          case 'savadefault':
            this.nzFormGroupData['nzValue']['nzValue'] = this.form.get(this.nzFormGroupData['nzKey']).value;
            break;

          default:
            break;
        }
      }
      )
    }, 100);

  }

}
